import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[imageFallback]',
  standalone: true
})
export class ImageFallback {

  @Input() imageFallback: string;

  constructor(private eRef: ElementRef) { }

  @HostListener('error')
  loadFallbackOnError() {
    const element: HTMLImageElement = this.eRef.nativeElement as HTMLImageElement;
    if (this.imageFallback) {
      element.src = this.imageFallback;
    } else {
      let { width, height } = element;
      console.log('e2', width, height);
      if (width > height) {
        element.src = 'assets/images/placeholder/placeholder-horizontal.webp';
      } else if (width < height) {
        element.src = 'assets/images/placeholder/placeholder-vertical.webp';
      } else {
        element.src = 'assets/images/placeholder/placeholder-square.webp';
      }
      // element.src = this.imageFallback || 'assets/images/placeholder/image-fallback.png';
    }
  }

}
